"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionService = void 0;
var aesService_1 = require("./aesService");
var compressionService_1 = require("./compressionService");
var EncryptionService = /** @class */ (function () {
    function EncryptionService() {
    }
    /**
     * Generate a new encryption key, optionally from a passphrase
     */
    EncryptionService.prototype.generateKey = function (input) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, aesService_1.generateKey)(input)];
            });
        });
    };
    /**
     * Compress text and update encryption state
     */
    EncryptionService.prototype.compressText = function (text, currentState) {
        return __awaiter(this, void 0, void 0, function () {
            var result, output, updatedState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, compressionService_1.compressAuto)(text)];
                    case 1:
                        result = _a.sent();
                        output = result.output;
                        updatedState = {
                            isEncrypted: false,
                            isLocked: false,
                            isCompressed: true,
                            compressedMode: result.mode,
                            preamble: currentState === null || currentState === void 0 ? void 0 : currentState.preamble
                        };
                        return [2 /*return*/, { result: output, state: updatedState }];
                }
            });
        });
    };
    /**
     * Encrypt text and update encryption state
     */
    EncryptionService.prototype.encryptText = function (text, key, compress, preamble, currentState) {
        if (compress === void 0) { compress = true; }
        return __awaiter(this, void 0, void 0, function () {
            var contentToEncrypt, autoResult, encrypted, finalResult, updatedState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, aesService_1.ensureKeyHex)(key);
                        if (!compress) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, compressionService_1.compressAuto)(text)];
                    case 1:
                        autoResult = _a.sent();
                        contentToEncrypt = autoResult.output;
                        return [3 /*break*/, 3];
                    case 2:
                        contentToEncrypt = text;
                        _a.label = 3;
                    case 3: return [4 /*yield*/, (0, aesService_1.encrypt)(contentToEncrypt, key)];
                    case 4:
                        encrypted = _a.sent();
                        finalResult = preamble ? "s1 > ".concat(preamble, " > ").concat(encrypted) : encrypted;
                        updatedState = {
                            isEncrypted: true,
                            isLocked: true,
                            isCompressed: compress,
                            compressedMode: compress ? 'gzip' : 'none',
                            preamble: preamble
                        };
                        return [2 /*return*/, { result: finalResult, state: updatedState }];
                }
            });
        });
    };
    /**
     * Decrypt text and update encryption state
     */
    EncryptionService.prototype.decryptText = function (encryptedText, key, currentState) {
        return __awaiter(this, void 0, void 0, function () {
            var parsed, actualEncrypted, decrypted, finalResult, _a, updatedState;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (0, aesService_1.ensureKeyHex)(key);
                        parsed = (0, compressionService_1.parseCompressedPreamble)(encryptedText);
                        actualEncrypted = parsed ? parsed.compressedData : encryptedText;
                        return [4 /*yield*/, (0, aesService_1.decrypt)(actualEncrypted, key)];
                    case 1:
                        decrypted = _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, (0, compressionService_1.decompressAfterDecryption)(decrypted)];
                    case 3:
                        finalResult = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _b.sent();
                        // If decompression fails, return as-is (might not have been compressed)
                        finalResult = decrypted;
                        return [3 /*break*/, 5];
                    case 5:
                        updatedState = {
                            isEncrypted: false,
                            isLocked: false,
                            isCompressed: false,
                            compressedMode: undefined,
                            preamble: (parsed === null || parsed === void 0 ? void 0 : parsed.preamble) || (currentState === null || currentState === void 0 ? void 0 : currentState.preamble)
                        };
                        return [2 /*return*/, { result: finalResult, state: updatedState }];
                }
            });
        });
    };
    /**
     * Decompress text and update encryption state
     */
    EncryptionService.prototype.decompressText = function (compressedText, currentState) {
        return __awaiter(this, void 0, void 0, function () {
            var parsed, decompressed, preamble, innerContent, _a, updatedState;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        parsed = (0, compressionService_1.parseCompressedPreamble)(compressedText);
                        if (!parsed) return [3 /*break*/, 5];
                        innerContent = parsed.compressedData;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, compressionService_1.decompressAfterDecryption)(innerContent)];
                    case 2:
                        decompressed = _b.sent();
                        preamble = parsed.preamble;
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        // If decompression fails, this might be encrypted content, not compressed
                        throw new Error('Content appears to be encrypted, not compressed');
                    case 4: return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, (0, compressionService_1.decompressAfterDecryption)(compressedText)];
                    case 6:
                        // Handle legacy compressed format
                        decompressed = _b.sent();
                        _b.label = 7;
                    case 7:
                        updatedState = {
                            isEncrypted: false,
                            isLocked: false,
                            isCompressed: false,
                            compressedMode: undefined,
                            preamble: preamble || (currentState === null || currentState === void 0 ? void 0 : currentState.preamble)
                        };
                        return [2 /*return*/, { result: decompressed, state: updatedState }];
                }
            });
        });
    };
    /**
     * Initialize encryption state for a row based on its content
     * Default to not encrypted/locked - let tryAutoDecode determine the actual state
     * by attempting operations (decompress/decrypt) and handling failures
     */
    EncryptionService.prototype.initializeRowState = function (pnBody) {
        if (!pnBody) {
            // Handle null/undefined pnBody - treat as plain text
            return {
                isEncrypted: false,
                isLocked: false,
                isCompressed: false,
                compressedMode: undefined,
                preamble: undefined
            };
        }
        var parsed = (0, compressionService_1.parseCompressedPreamble)(pnBody);
        var preamble;
        if (parsed) {
            // Has preamble format - we can't reliably detect if inner content is encrypted or compressed
            // without trying to decompress/decrypt. Default to not encrypted (will be corrected by tryAutoDecode)
            preamble = parsed.preamble;
        }
        // Default to not encrypted/locked - let tryAutoDecode determine the actual state by attempting operations
        return {
            isEncrypted: false,
            isLocked: false,
            isCompressed: false,
            compressedMode: undefined,
            preamble: preamble
        };
    };
    /**
     * Store key in session storage (temporary)
     */
    EncryptionService.prototype.storeKey = function (key) {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('audroam_encryption_key', key);
        }
    };
    /**
     * Retrieve stored key
     */
    EncryptionService.prototype.getStoredKey = function () {
        if (typeof sessionStorage !== 'undefined') {
            return sessionStorage.getItem('audroam_encryption_key');
        }
        return null;
    };
    /**
     * Clear stored key from session storage
     */
    EncryptionService.prototype.clearStoredKey = function () {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('audroam_encryption_key');
        }
    };
    /**
     * Parse compressed preamble from text
     */
    EncryptionService.prototype.parseCompressedPreamble = function (text) {
        return (0, compressionService_1.parseCompressedPreamble)(text);
    };
    return EncryptionService;
}());
exports.EncryptionService = EncryptionService;
